'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Industry {
  id: string;
  name: string;
  icon: string;
}

interface IndustryFilterProps {
  industries: Industry[];
  onFilterChange: (selectedIndustries: string[]) => void;
}

const IndustryFilter = ({ industries, onFilterChange }: IndustryFilterProps) => {
  const [selectedIndustries, setSelectedIndustries] = useState<string[]>([]);

  const toggleIndustry = (industryId: string) => {
    const updated = selectedIndustries.includes(industryId)
      ? selectedIndustries.filter(id => id !== industryId)
      : [...selectedIndustries, industryId];
    
    setSelectedIndustries(updated);
    onFilterChange(updated);
  };

  const clearFilters = () => {
    setSelectedIndustries([]);
    onFilterChange([]);
  };

  return (
    <div data-component-id="src/app/solutions-overview/components/IndustryFilter.tsx:35:4" data-component-path="src/app/solutions-overview/components/IndustryFilter.tsx" data-component-line="35" data-component-file="IndustryFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-xl%20border%20border-border%20p-6%20shadow-elevation%22%7D" className="bg-card rounded-xl border border-border p-6 shadow-elevation">
      <div data-component-id="src/app/solutions-overview/components/IndustryFilter.tsx:36:6" data-component-path="src/app/solutions-overview/components/IndustryFilter.tsx" data-component-line="36" data-component-file="IndustryFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20mb-4%22%7D" className="flex items-center justify-between mb-4">
        <h3 data-component-id="src/app/solutions-overview/components/IndustryFilter.tsx:37:8" data-component-path="src/app/solutions-overview/components/IndustryFilter.tsx" data-component-line="37" data-component-file="IndustryFilter.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-text-primary%22%2C%22textContent%22%3A%22Filter%20by%20Industry%22%7D" className="text-lg font-semibold text-text-primary">Filter by Industry</h3>
        {selectedIndustries.length > 0 && (
          <button data-component-id="src/app/solutions-overview/components/IndustryFilter.tsx:39:10" data-component-path="src/app/solutions-overview/components/IndustryFilter.tsx" data-component-line="39" data-component-file="IndustryFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22text-sm%20text-primary%20hover%3Atext-primary%2F80%20font-medium%20transition-smooth%22%2C%22textContent%22%3A%22Clear%20All%22%7D"
            onClick={clearFilters}
            className="text-sm text-primary hover:text-primary/80 font-medium transition-smooth"
          >
            Clear All
          </button>
        )}
      </div>

      <div data-component-id="src/app/solutions-overview/components/IndustryFilter.tsx:48:6" data-component-path="src/app/solutions-overview/components/IndustryFilter.tsx" data-component-line="48" data-component-file="IndustryFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%22%7D" className="flex flex-wrap gap-3">
        {industries.map((industry) => {
          const isSelected = selectedIndustries.includes(industry.id);
          return (
            <button data-component-id="src/app/solutions-overview/components/IndustryFilter.tsx:52:12" data-component-path="src/app/solutions-overview/components/IndustryFilter.tsx" data-component-line="52" data-component-file="IndustryFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
              key={industry.id}
              onClick={() => toggleIndustry(industry.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg border transition-smooth ${
                isSelected
                  ? 'bg-primary text-white border-primary' :'bg-background text-text-secondary border-border hover:border-primary hover:text-primary'
              }`}
            >
              <Icon data-component-id="src/app/solutions-overview/components/IndustryFilter.tsx:60:14" data-component-path="src/app/solutions-overview/components/IndustryFilter.tsx" data-component-line="60" data-component-file="IndustryFilter.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={industry.icon as any} size={18} />
              <span data-component-id="src/app/solutions-overview/components/IndustryFilter.tsx:61:14" data-component-path="src/app/solutions-overview/components/IndustryFilter.tsx" data-component-line="61" data-component-file="IndustryFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%20font-medium%22%7D" className="text-sm font-medium">{industry.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default IndustryFilter;